import { z } from "zod";

export enum ReviewView {
  Global = "global",
  Organization = "organization",
}

export const Events = {
  "web:takedown_drawer_open": z.object({
    takedown_id: z.number().optional(),
    takedown_status: z.string(),
  }),
  "web:takedown_email_send": z.object({
    takedown_id: z.number().nullable(),
  }),
  "web:takedown_retraction_email_send": z.object({
    takedown_id: z.number().nullable(),
  }),
  "web:takedown_email_cancel": z.object({
    takedown_id: z.number().nullable(),
  }),
  "web:takedown_retraction_email_cancel": z.object({
    takedown_id: z.number().nullable(),
  }),
  "web:takedown_email_content_copy": z.object({
    takedown_id: z.number().nullable(),
  }),
  "web:retraction_email_content_copy": z.object({
    takedown_id: z.number().nullable(),
  }),
  "web:takedown_gmail_redirect": z.object({
    takedown_id: z.number().nullable(),
  }),
  "web:retraction_gmail_redirect": z.object({
    takedown_id: z.number().nullable(),
  }),
  "web:takedown_mark_as_complete": z.object({
    takedown_id: z.number().nullable(),
    user_id: z.number().optional(),
  }),
  "web:takedown_unassign_user": z.object({
    takedown_id: z.number().nullable(),
  }),
  "web:takedown_assign_user": z.object({
    takedown_id: z.number().nullable(),
    assigned_user_id: z.number(),
  }),
  "web:takedown_action_click": z.object({
    takedown_id: z.number().nullable(),
    action: z.string(),
  }),
  "web:takedown_refile_done": z.object({
    takedown_id: z.number().nullable(),
  }),

  // Detection Config modal
  "web:detection_config_modal_generate_config": z.object({
    user_id: z.number().optional(),
  }),
  "web:detection_config_modal_generate_config_discard": z.object({
    user_id: z.number().optional(),
  }),
  "web:detection_config_modal_generate_config_apply": z.object({
    user_id: z.number().optional(),
  }),

  // Threats page
  "web:threats_filters_apply": z.object({
    filters: z.array(
      z.object({
        id: z.string(),
        label: z.string(),
        options: z.object({}),
        values: z.array(z.string()).optional(),
      }),
    ),
  }),

  // Staff page
  "web:staff_threats_redirect": z.object({
    user_id: z.number().optional(),
    slug: z.string(),
  }),
  "web:staff_filter_needs_review": z.object({
    user_id: z.number().optional(),
  }),
  "web:staff_filter_no_reporting_wave": z.object({
    user_id: z.number().optional(),
  }),
  "web:staff_view_change": z.object({
    user_id: z.number().optional(),
    view: z.enum(["all", "detection", "reporting", "reviewing", "takedowns"]),
  }),
  "api:key_used": z.object({
    user_id: z.string().optional(),
    path: z.string(),
    is_legacy: z.boolean().optional(),
    params: z.object({
      query: z.object({}),
      body: z.object({}),
    }),
  }),
  // Review Proposal
  "web:review_approve": z.object({
    organization_id: z.number(),
    report_id: z.number(),
    proposal_id: z.number(),
    view: z.enum(["global", "organization"]),
    reason: z.string(),
  }),
  "web:review_reject": z.object({
    organization_id: z.number(),
    report_id: z.number(),
    proposal_id: z.number(),
    view: z.enum(["global", "organization"]),
  }),
  "web:watchlist_toggle": z.object({
    organization_id: z.number(),
    report_id: z.number(),
    proposal_id: z.number(),
    view: z.enum(["global", "organization"]),
  }),
  "web:false_positive_flag": z.object({
    organization_id: z.number(),
    report_id: z.number(),
    proposal_id: z.number(),
    view: z.enum(["global", "organization"]),
    reason: z.string(),
  }),

  // Takedown Drawer
  "web:takedown_start": z.object({
    organization_id: z.number(),
    asset_id: z.number(),
    asset_type: z.string(),
    takedown_id: z.number(),
    takedown_assignee_id: z.number(),
  }),
  "web:takedown_cancel": z.object({
    organization_id: z.number(),
    asset_id: z.number(),
    asset_type: z.string(),
    takedown_id: z.number(),
    takedown_assignee_id: z.number(),
  }),
  "web:takedown_refresh_click": z.object({
    takedown_id: z.number().nullable(),
  }),
  "web:takedown_bulk_refresh_click": z.object({
    takedown_ids: z.array(z.number().nullable()),
  }),

  // Detection Results
  "web:detection_result_select": z.object({
    organization_id: z.number(),
    detection_result_id: z.number(),
    source: z.string(),
  }),
  "web:detection_create_report": z.object({
    organization_id: z.number(),
    detection_result_ids: z.array(z.number()),
  }),

  "web:detection_copy_content": z.object({
    organization_id: z.number(),
    detection_result_id: z.number(),
    source: z.string(),
  }),

  // Threats page
  "web:threats_copy_to_clipboard": z.object({
    organization_id: z.number(),
    takedown_assignee_id: z.number(),
  }),
};

export type EventName = keyof typeof Events;
